import { useEffect } from "react";
import { useI18n } from "@/i18n/I18nProvider";

export default function Privacy() {
  const { t } = useI18n();
  useEffect(() => {
    const id = "iubenda-js";
    if (!document.getElementById(id)) {
      const s = document.createElement("script");
      s.id = id;
      s.async = true;
      s.src = "https://cdn.iubenda.com/iubenda.js";
      document.body.appendChild(s);
    }
  }, []);
  return (
    <div className="container mx-auto px-6 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-4">{t('legal.privacy.title', 'Privacy Policy')}</h1>
      <a
        href="https://www.iubenda.com/privacy-policy/54070684"
        className="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe"
        title={t('legal.privacy.title', 'Privacy Policy')}
      >
        {t('legal.privacy.open_link', 'Open the Privacy Policy')}
      </a>
      <div className="py-4 text-sm text-gray-600">
        {t('legal.privacy.fallback', 'Display issues?')}{" "}
        <a className="text-primary underline" href="https://www.iubenda.com/privacy-policy/54070684" target="_blank" rel="noreferrer">
          {t('legal.privacy.fallback_link', 'Open the policy on iubenda.com')}
        </a>.
      </div>
    </div>
  );
}
